'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchManualLookupOptions = exports.lookupReg = exports.selectVehicle = exports.setManualView = exports.resetVehicleLookup = undefined;
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
var _constants = require('../constants');
var _vehicleLookup = require('../selectors/vehicle-lookup');
var _updateFields = require('../actions/update-fields');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
var resetVehicleLookup = exports.resetVehicleLookup = function resetVehicleLookup(formId) {
  return {
    type: _constants.actionTypes.RESET_VEHICLE_LOOKUP,
    formId: formId
  };
};
var setManualView = exports.setManualView = function setManualView(formId) {
  return {
    type: _constants.actionTypes.SET_MANUAL_VIEW,
    formId: formId
  };
};
var selectVehicle = exports.selectVehicle = function selectVehicle(formId, index) {
  return function (dispatch, getState) {
    var vehicle = (0, _vehicleLookup.cdlOptions)(formId, true)(getState())[index];
    dispatch((0, _updateFields.resetFields)(formId, ['abiCode', 'value']));
    dispatch((0, _updateFields.setValues)(formId, {
      abiCode: vehicle.model.abiCode,
      value: vehicle.valuation ? vehicle.valuation.forecourtValue.toString() : ''
    }));
    dispatch({
      type: _constants.actionTypes.SELECT_VEHICLE,
      formId: formId,
      index: index
    });
  };
};
var lookupReg = exports.lookupReg = function lookupReg(formId, product, regNo) {
  return function (dispatch, getState) {
    dispatch((0, _updateFields.resetFields)(formId, ['abiCode', 'value']));
    dispatch({
      type: _constants.actionTypes.REG_LOOKUP,
      payload: _axios2.default.post((0, _constants.vehicleLookupUrls)(product).reg, {
        product: product,
        regNo: regNo
      }).then(function (response) {
        window.dataLayer.push({
          event: 'aa_lookup',
          aa: {
            lookup_name: 'car registration',
            lookup_result: 'success',
            error_message: ''
          }
        });
        if (response.data.status === 'SUCCESS' && response.data.data.length === 1) {
          dispatch((0, _updateFields.setValues)(formId, {
            abiCode: response.data.data[0].model.abiCode,
            value: response.data.data[0].valuation && response.data.data[0].valuation.forecourtValue ? response.data.data[0].valuation.forecourtValue.toString() : ''
          }));
        }
        return response.data;
      }, function (error) {
        window.dataLayer.push({
          event: 'aa_lookup',
          aa: {
            lookup_name: 'car registration',
            lookup_result: 'failure',
            error_message: error.message
          }
        });
        throw error;
      }),
      meta: {
        formId: formId
      }
    });
  };
};
var optionsToWipe = {
  getManufacturerOptions: ['manufacturerOptions'],
  getModelOptions: ['modelOptions', 'transOptions', 'fuelOptions', 'engineOptions', 'trimOptions', 'doorsOptions', 'yearOptions'],
  getTransOptions: ['transOptions', 'fuelOptions', 'engineOptions', 'trimOptions', 'doorsOptions', 'yearOptions'],
  getFuelOptions: ['fuelOptions', 'engineOptions', 'trimOptions', 'doorsOptions', 'yearOptions'],
  getEngineOptions: ['engineOptions', 'trimOptions', 'doorsOptions', 'yearOptions'],
  getTrimOptions: ['trimOptions', 'doorsOptions', 'yearOptions'],
  getDoorsOptions: ['doorsOptions', 'yearOptions'],
  getYearOptions: ['yearOptions'],
  getVehicle: []
};
var fetchManualLookupOptions = exports.fetchManualLookupOptions = function fetchManualLookupOptions(formId, product, action, name) {
  return function (dispatch, getState) {
    dispatch((0, _updateFields.resetFields)(formId, ['abiCode', 'value', 'regNo'].concat(_toConsumableArray(optionsToWipe[action]))));
    dispatch({
      type: _constants.actionTypes.CLEAR_MANUAL_LOOKUP_OPTIONS,
      fields: optionsToWipe[action],
      formId: formId
    });
    dispatch({
      type: _constants.actionTypes.MANUAL_LOOKUP,
      payload: _axios2.default.post((0, _constants.vehicleLookupUrls)(product).manual, Object.assign({
        product: product,
        action: action
      }, (0, _vehicleLookup.manualLookupValues)(getState(), formId))).then(function (response) {
        if (response.data.data.abiCode || response.data.data.vehicle) {
          dispatch((0, _updateFields.setValue)(formId, 'abiCode', response.data.data.abiCode || response.data.data.vehicle.abiCode));
        } else {
          // check for known values
          ['modelOptions', 'transOptions', 'fuelOptions', 'engineOptions', 'trimOptions', 'doorsOptions', 'yearOptions'].forEach(function (field) {
            if (response.data.data[field] && response.data.data[field].length === 1) {
              // and set them
              dispatch((0, _updateFields.setValue)(formId, field, response.data.data[field][0].value));
            }
          });
        }
        return response.data;
      }),
      meta: {
        formId: formId,
        action: action,
        name: name
      }
    });
  };
};